import {NgModule} from '@angular/core';
import {LatLngLinkComponent} from './lat-lng-link.component';
import {SharedModule} from '../shared.module';

export const MODULE_DECLARATIONS = [LatLngLinkComponent];
export const MODULE_IMPORTS = [SharedModule];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: [LatLngLinkComponent],
})
export class LatLngLinkModule {}
